import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import logo from "../../assets/img/logo.JPG"; 
import { useTheme } from "@mui/material/styles";
function About() {
  const theme = useTheme();
  return (
    <Box>
      {/* About Drips Heading */}
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          color:theme.palette.secondary.main, // grey color
          mb: 8,
          mt:3,
          p:3
        }}
      >
        <span style={{ color: "#0096FF" }}>About</span> Drips
      </Typography>

      {/* Content Section */}
      <Grid container spacing={4} alignItems="center" sx={{ background: "linear-gradient(to right, #C7E7FF, #C7E7EE)",padding:"2rem"}}>
        {/* Left Side - Image */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <img
              src={logo} 
              alt="Drips Water Logo"
              style={{ width: "100%", maxWidth: "300px" }}
            />
          </Box>
        </Grid>

        {/* Right Side - Text */}
        <Grid item xs={12} md={8}>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              color: "#888585",
              lineHeight: 1.6,
              textAlign: "justify",
            }}
          >
            Drips Water is a platform dedicated to making mineral water delivery
            quick, easy, and convenient. The platform offers a wide range of
            mineral water jars and bottles of various sizes. From small orders
            for households to bulk deliveries for businesses and events, Drips
            Water provides a seamless experience. Their focus on customer
            satisfaction, punctuality, and quality has made them a go-to service
            for anyone in need of pure drinking water. The partnership between
            Drips Water and Aadi Aqua has revolutionized water delivery services.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default About;
